"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var csrf = require("../../pages/csrfUtils");
// tslint:disable-next-line:no-var-requires
var styles = require('./follow.css');
exports.updateFollowing = function (handle, follow, updateCounts) {
    return {
        type: 'TOGGLE_FOLLOWING',
        handle: handle,
        isFollowing: follow,
        updateCounts: updateCounts,
    };
};
exports.followState = function (state, action) {
    if (state === void 0) { state = { isFollowing: false, handle: '' }; }
    switch (action.type) {
        case 'TOGGLE_FOLLOWING':
            return {
                handle: action.handle,
                isFollowing: !!action.isFollowing,
            };
        default:
            return state;
    }
};
exports.mapStateToProps = function (state) {
    return {
        loginUrl: !state.user.handle ? state.loginUrl.loginUrl : false,
        handle: state.follow.handle,
        updateCounts: state.profile.handle === state.user.handle,
        isFollowing: state.follow.isFollowing,
    };
};
exports.dispatchToggleFollow = function (dispatch, handle, isFollowing, updateCounts) {
    dispatch(exports.updateFollowing(handle, isFollowing, updateCounts));
    // update status so we are not waiting for ajax request, then make fetch request
    // doing this here means the ajax request is only completed on button inputs, not in server updates
    fetch(isFollowing ? '/follow' : '/follow', {
        method: isFollowing ? 'POST' : 'DELETE',
        credentials: 'same-origin',
        body: JSON.stringify({ followee: handle }),
        headers: csrf.withCSRFToken({
            'Content-Type': 'application/json',
        }),
    })
        .then(function (res) {
        if (res.status === 200) {
            return;
        }
        // status contained an error, undo UI update
        dispatch(exports.updateFollowing(handle, !isFollowing, updateCounts));
    })
        .catch(function (err) {
        console.log('error updating follow status', err);
        dispatch(exports.updateFollowing(handle, !isFollowing, updateCounts));
    });
};
exports.mapDispatchToProps = function (dispatch) {
    return {
        toggleFollowing: function (handle, isFollowing, updateCounts) {
            exports.dispatchToggleFollow(dispatch, handle, isFollowing, updateCounts);
        },
    };
};
var followButton = function (_a) {
    var loginUrl = _a.loginUrl, handle = _a.handle, isFollowing = _a.isFollowing, updateCounts = _a.updateCounts, toggleFollowing = _a.toggleFollowing;
    return (React.createElement("div", { className: styles.follow },
        React.createElement("div", { className: styles.followButton, onClick: function () {
                return loginUrl ? window.location.replace(loginUrl) : toggleFollowing(handle, !isFollowing, updateCounts);
            } }, isFollowing ? 'Following' : 'Follow')));
};
exports.FollowButton = react_redux_1.connect(exports.mapStateToProps, exports.mapDispatchToProps)(followButton);
